import * as React from "react";
import {NotDefaultSearchWarning} from "../../Components/Search/Components/NotDefaultSearchWarning";
import {ListAlertContainer} from "../../Components/ListAlertContainer";

export const SearchAlert = () => (
    <ListAlertContainer>
        <NotDefaultSearchWarning />
    </ListAlertContainer>
);
